// Layout settings (grouping, orientation, list/grid, alignment) live on the
// page theme - the product carries the per-axis tab content maps plus the
// heading settings above the options.
export const PRICE_PICKER_KEYS = [
  'priceDisplayLabels',
  'priceDisplayDefaults',
  'priceDisplayTabOrder',
  'pricePickerTitle',
  'pricePickerDescription',
  'shortenDescription',
];

// Flat form names that differ from the nested API names: the form already has
// a product `title` and `description`, so the picker's carry a prefix.
const NESTED_NAME = {
  pricePickerTitle: 'title',
  pricePickerDescription: 'description',
};

/**
 * The price-picker form state is flat (Formik fields like `values.groupBy`)
 * but the API stores them nested under `product.pricePicker`. Nest at the
 * submit boundary so the intricate PriceGrouping UI keeps its flat fields.
 * `pricePicker` is only attached when the payload carries at least one of
 * the keys — scoped submits without them (e.g. a title autosave) stay
 * untouched.
 */
export function toProductPayload(values) {
  const rest = { ...values };
  const pricePicker = {};
  let hasAny = false;
  for (const key of PRICE_PICKER_KEYS) {
    if (key in rest) {
      pricePicker[NESTED_NAME[key] ?? key] = rest[key];
      delete rest[key];
      hasAny = true;
    }
  }
  return hasAny ? { ...rest, pricePicker } : rest;
}
